import React, { useState } from 'react';
import { Form, Col, Alert, Button } from 'react-bootstrap';
import FormControl from './FormControl';
import ReCAPTCHA from 'react-google-recaptcha';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCheck } from '@fortawesome/free-solid-svg-icons'

function BookingCustomerInfo(props) {
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    const [recaptcha, setRecaptcha] = useState();
    const [validated, setValidated] = useState(false);
    const [givenname, setGivenname] = useState('');
    const [surname, setSurname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [petName, setPetName] = useState('');
    const [petType, setPetType] = useState('');
    const [message, setMessage] = useState('');
    const [submitEnabled, setSubmitEnabled] = useState(false);

    const handleSubmit = event => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            event.preventDefault();
            event.stopPropagation();
            const customer = {
                givenname: givenname,
                surname: surname,
                phone: phone,
                email: email,
                petName: petName,
                petType: petType,
                recaptcha: recaptcha,
                message: message
            }
            props.onSaved(customer);
        }
        setValidated(true);
    };

    function recaptchaChanged(value) {
        setRecaptcha(value);
        setSubmitEnabled(true);
    }

    function getSubmitButton() {
        if (submitEnabled) {
            return (
                <Button size="lg" variant="book" type="submit">
                    Boka
                </Button>
            );
        } else {
            return (
                <Button size="lg" disabled variant="disabled-book" type="submit">
                    Boka
                </Button>
            );
        }
    }

    function isShown() {
        return props.shownControl === 'customer'
    }

    function hasData() {
        return givenname !== ''
    }

    if (!isShown()) {
        if (!hasData()) {
            return (
                <Alert variant="section-header">
                    <FontAwesomeIcon icon={faUserCheck} style={{ marginRight: 10 }} />
                    Kundinformation
                </Alert>
            );
        } else {
            return (
                <Alert variant="saved-header">
                    <FontAwesomeIcon icon={faUserCheck} style={{ marginRight: 10 }} />
                    Kundinformation: <b>{givenname} {surname}</b>
                </Alert>
            );
        }
    }
    else {
        return (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Row>
                    <FormControl
                        required={true}
                        controlId="formGridGivenname"
                        label="Förnamn"
                        value={givenname}
                        onChange={setGivenname}
                        type="text"
                        placeholder="Ange förnamn">
                    </FormControl>
                    <FormControl
                        required={true}
                        controlId="formGridSurname"
                        label="Efternamn"
                        value={surname}
                        onChange={setSurname}
                        type="text"
                        placeholder="Ange efternamn">
                    </FormControl>
                </Form.Row>
                <Form.Row>
                    <FormControl
                        required={true}
                        controlId="formGridEmail"
                        label="E-post"
                        value={email}
                        onChange={setEmail}
                        type="email"
                        placeholder="Ange e-post">
                    </FormControl>
                    <FormControl
                        required={true}
                        controlId="formGridPhone"
                        label="Telefon"
                        value={phone}
                        onChange={setPhone}
                        type="text"
                        placeholder="Ange telefonnummer">
                    </FormControl>
                </Form.Row>
                <Form.Row>
                    <FormControl
                        required={false}
                        controlId="formGridPetName"
                        label="Djurets namn"
                        value={petName}
                        onChange={setPetName}
                        type="text"
                        placeholder="Ange djurets namn">
                    </FormControl>
                    <FormControl
                        required={false}
                        controlId="formGridPetType"
                        label="Djurslag"
                        value={petType}
                        onChange={setPetType}
                        type="text"
                        placeholder="Ange djurslag">
                    </FormControl>
                </Form.Row>
                <Form.Row>
                    <FormControl
                        required={false}
                        controlId="formGridMessage"
                        label="Ev. meddelande"
                        value={message}
                        onChange={setMessage}
                        type="text"
                        placeholder="Lämna ev. meddelande">
                    </FormControl>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} controlId="formGridReCaptcha">
                        <ReCAPTCHA onChange={recaptchaChanged} sitekey={siteKey} />
                    </Form.Group>
                </Form.Row>
                {getSubmitButton()}
            </Form>
        );
    }

}

export default BookingCustomerInfo;